import { render, staticRenderFns } from "./ProductsMarketsMatrix.vue?vue&type=template&id=41b1bc38&scoped=true&"
import script from "./ProductsMarketsMatrix.vue?vue&type=script&lang=ts&"
export * from "./ProductsMarketsMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsMarketsMatrix.vue?vue&type=style&index=0&id=41b1bc38&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1bc38",
  null
  
)

export default component.exports